export const B2C_FLOWS = {
  editProfile: process.env.REACT_APP_B2C_POLICY_EDIT_PROFILE,
  passwordReset: process.env.REACT_APP_B2C_POLICY_PASSWORD_RESET,
  passwordResetEmail: process.env.REACT_APP_B2C_POLICY_PASSWORD_RESET_EMAIL,
};

export const REDIRECT_PATH = '';

/**
 * Generates a URL to a specific B2c flow.
 *
 * @param flow - Open for extension, currently handling change password and edit profile.
 * @param state - Optional that will default to the flowId.
 * @returns string - URL to the B2C flow.
 */
export const getB2CLink = (flow: keyof typeof B2C_FLOWS, state?: string): string => {
  const flowId = B2C_FLOWS[flow];
  const b2cState = state ?? flowId;

  const redirectUri = `${window.location.origin}/${REDIRECT_PATH}`;

  const b2cLink = `${
    process.env.REACT_APP_B2C_AUTHORITY
  }/oauth2/v2.0/authorize?p=${flowId}&client_id=${
    process.env.REACT_APP_B2C_CLIENT_ID
  }&nonce=defaultNonce&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&scope=openid&response_type=id_token&state=${b2cState}&lang=en`;

  return b2cLink.replace(/'/g, '').replace(/;/g, '');
};
